module.exports = __webpack_public_path__ + "static/media/ic_calendar.4d322c1d.svg";